import { FC } from 'react';
import { Flex, Icon, Text } from '@servicetitan/anvil2';
import IconPictureAsPdf from '@servicetitan/anvil2/assets/icons/material/round/picture_as_pdf.svg';
import IconRemoveRedEye from '@servicetitan/anvil2/assets/icons/material/round/remove_red_eye.svg';

import { EquipmentDocumentApiModel } from '../../api/equipments.api';
import { MessageBubble } from '../message-bubble/message-bubble';

import * as Styles from './download-document.module.less';

export interface DownloadDocumentProps {
    documents: {
        doc: EquipmentDocumentApiModel;
        page: number;
    }[];
    onViewPdf: (document: EquipmentDocumentApiModel, page: number) => void;
}

export const DownloadDocument: FC<DownloadDocumentProps> = ({ documents, onViewPdf }) => {
    return (
        <Flex gap="1" direction="column">
            {documents.map(document => {
                return (
                    <MessageBubble
                        key={document.doc.id}
                        isMine={false}
                        className={Styles.downloadDocumentContainer}
                    >
                        <a
                            target="_blank"
                            onClick={() => {
                                onViewPdf(document.doc, document.page);
                            }}
                            rel="noreferrer"
                            download
                        >
                            <div
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'auto 1fr auto',
                                    columnGap: '8px',
                                    alignItems: 'center',
                                    padding: '8px',
                                    borderLeft: '8px solid #E0F2FF',
                                }}
                            >
                                <Icon
                                    svg={IconPictureAsPdf}
                                    size="large"
                                    style={{
                                        padding: '8px',
                                        backgroundColor: '#F7F7F7',
                                        borderRadius: '8px',
                                    }}
                                />
                                <Text size="small" flexGrow={1}>
                                    <b>
                                        {document.doc.download_file_name}{' '}
                                        {document.page ? `(page ${document.page})` : ''}
                                    </b>
                                </Text>
                                <Icon svg={IconRemoveRedEye} size="large" />
                            </div>
                        </a>
                    </MessageBubble>
                );
            })}
        </Flex>
    );
};
